const development = false;

export const settings = {
    baseURL:  development ? "http://localhost:4000" :"https://api-inspection.erpsoft.net",
    apiURL:  development ? "http://localhost:4000/api/v1" :"https://api-inspection.erpsoft.net/api/v1",
}
